import React, { useState } from "react";

const CANCEL_REASONS = [
  "Completed my project",
  "Too expensive",
  "Missing features",
  "Hard to use",
  "Just testing",
  "Other",
];

function CancelSubscriptionModal({ onClose, onConfirm }) {
  const [step, setStep] = useState(1);
  const [reason, setReason] = useState("");

  return (
    <div
      style={{ position: "fixed", inset: 0, zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center" }}
      onClick={onClose}
    >
      <div style={{ position: "absolute", inset: 0, backgroundColor: "rgba(0,0,0,0.65)", backdropFilter: "blur(4px)" }} />

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          backgroundColor: "#0f0d1a",
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: "1.25rem",
          padding: "1.75rem",
          width: "min(90vw, 430px)",
          boxShadow: "0 32px 64px rgba(0,0,0,0.6)",
        }}
      >
        {step === 1 && (
          <>
            <h3 style={{ color: "#fff", fontSize: "1.05rem", fontWeight: 700, marginBottom: "0.4rem", fontFamily: "Manrope,sans-serif" }}>
              How can we do better?
            </h3>
            <p style={{ color: "#9c98bf", fontSize: "0.83rem", marginBottom: "1.25rem", lineHeight: 1.6, fontFamily: "Manrope,sans-serif" }}>
              We'd love to know what prompted your cancellation so we can improve.
            </p>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem", marginBottom: "1.5rem" }}>
              {CANCEL_REASONS.map((r) => (
                <label
                  key={r}
                  style={{
                    display: "flex", alignItems: "center", gap: "0.75rem",
                    padding: "0.75rem 1rem", borderRadius: "0.75rem", cursor: "pointer",
                    border: `1px solid ${reason === r ? "#7c5cff" : "rgba(255,255,255,0.05)"}`,
                    backgroundColor: reason === r ? "rgba(124,92,255,0.10)" : "rgba(255,255,255,0.02)",
                    transition: "all 0.15s ease",
                  }}
                >
                  <input
                    type="radio"
                    name="reason"
                    value={r}
                    checked={reason === r}
                    onChange={(e) => setReason(e.target.value)}
                    style={{ display: "none" }}
                  />
                  <div style={{
                    width: 16, height: 16, borderRadius: "50%", flexShrink: 0,
                    border: `2px solid ${reason === r ? "#7c5cff" : "rgba(255,255,255,0.2)"}`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    {reason === r && <div style={{ width: 8, height: 8, borderRadius: "50%", backgroundColor: "#7c5cff" }} />}
                  </div>
                  <span style={{ fontSize: "0.84rem", color: "#eee9ff", fontFamily: "Manrope,sans-serif", fontWeight: 500 }}>{r}</span>
                </label>
              ))}
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem" }}>
              <button
                onClick={onClose}
                style={{ padding: "0.55rem 1.1rem", fontSize: "0.83rem", color: "#9c98bf", background: "none", border: "none", cursor: "pointer", fontFamily: "Manrope,sans-serif" }}
              >
                Keep Plan
              </button>
              <button
                disabled={!reason}
                onClick={() => setStep(2)}
                style={{
                  padding: "0.55rem 1.25rem", fontSize: "0.83rem", fontWeight: 600,
                  backgroundColor: reason ? "#7c5cff" : "rgba(124,92,255,0.3)",
                  color: "#fff", border: "none", borderRadius: "0.65rem", cursor: reason ? "pointer" : "not-allowed",
                  fontFamily: "Manrope,sans-serif", transition: "background-color 0.15s",
                }}
              >
                Continue
              </button>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <h3 style={{ color: "#fff", fontSize: "1.05rem", fontWeight: 700, marginBottom: "0.4rem", fontFamily: "Manrope,sans-serif" }}>
              Confirm Cancellation
            </h3>
            <p style={{ color: "#9c98bf", fontSize: "0.83rem", marginBottom: "1.25rem", lineHeight: 1.6, fontFamily: "Manrope,sans-serif" }}>
              Are you sure you want to cancel? You'll lose access at the end of your billing cycle.
            </p>
            <div style={{ padding: "1.1rem", borderRadius: "1rem", backgroundColor: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.07)", marginBottom: "1.5rem" }}>
              <h4 style={{ color: "#fff", fontSize: "0.9rem", fontWeight: 600, marginBottom: "0.35rem", fontFamily: "Manrope,sans-serif" }}>Your projects are safe</h4>
              <p style={{ color: "#9c98bf", fontSize: "0.8rem", lineHeight: 1.6, fontFamily: "Manrope,sans-serif" }}>
                Even after cancellation, your projects, templates, and settings will remain securely saved.
              </p>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.75rem" }}>
              <button
                onClick={onClose}
                style={{ padding: "0.55rem 1.1rem", fontSize: "0.83rem", backgroundColor: "rgba(255,255,255,0.05)", color: "#eee9ff", border: "1px solid rgba(255,255,255,0.05)", borderRadius: "0.65rem", cursor: "pointer", fontFamily: "Manrope,sans-serif" }}
              >
                Keep Plan
              </button>
              <button
                onClick={() => { onConfirm(reason); setStep(3); }}
                style={{ padding: "0.55rem 1.25rem", fontSize: "0.83rem", fontWeight: 600, backgroundColor: "rgba(255,80,80,0.12)", color: "#ff5f57", border: "1px solid rgba(255,80,80,0.25)", borderRadius: "0.65rem", cursor: "pointer", fontFamily: "Manrope,sans-serif" }}
              >
                Cancel Subscription
              </button>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <h3 style={{ color: "#fff", fontSize: "1.05rem", fontWeight: 700, marginBottom: "0.4rem", fontFamily: "Manrope,sans-serif" }}>
              Cancellation Successful
            </h3>
            <p style={{ color: "#9c98bf", fontSize: "0.83rem", marginBottom: "1.5rem", lineHeight: 1.6, fontFamily: "Manrope,sans-serif" }}>
              Your subscription has been cancelled. You will continue to have premium access until the end of your current billing period.
            </p>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                onClick={onClose}
                style={{ padding: "0.55rem 1.25rem", fontSize: "0.83rem", backgroundColor: "rgba(255,255,255,0.08)", color: "#fff", border: "1px solid rgba(255,255,255,0.05)", borderRadius: "0.65rem", cursor: "pointer", fontFamily: "Manrope,sans-serif" }}
              >
                Close
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default CancelSubscriptionModal;
